import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  executionDepartment: Yup.string().required(
    'Odaberite jednu od ponuđenih opcija'
  ),
  priority: Yup.string().required('Odaberite prioritet radnog naloga'),
  description: Yup.string().required('Unesite opis poslova'),
  startDate: Yup.date().required('Odaberite datum i vrijeme'),
  endDate: Yup.date().required('Odaberite datum i vrijeme'),
});

export const initialValues = {
  description: '',
  note: '',
  priority: '',
  executionDepartment: '',
  startDate: null,
  endDate: null,
};
